import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import type { ButtonProps } from '@chakra-ui/react';
import { Button, HStack } from '@chakra-ui/react';

import type { ApiNotification } from '@izimi/api';
import { useModules } from '@izimi/modules';

interface NotificationSharedItemActionProps {
  notification: ApiNotification;
  targetPath: string;
  onAfterDelete?: () => void;
  buttonProps?: ButtonProps;
}

export const NotificationSharedItemAction = ({
  notification,
  targetPath,
  onAfterDelete,
  buttonProps,
}: NotificationSharedItemActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('notifications');

  const {
    notifications: { useDeleteNotification },
  } = useModules();
  const { deleteNotification, isPending } = useDeleteNotification();

  const handleClick = async () => {
    await deleteNotification(notification.id);
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
    if (onAfterDelete) {
      onAfterDelete();
    }
  };

  return (
    <HStack mt={2}>
      <Button
        variant='primary500'
        flex={1}
        onClick={handleClick}
        isLoading={isPending}
        {...buttonProps}>
        {t('watch')}
      </Button>
    </HStack>
  );
};
